(() => {
  const selector =
    'product-card video.allisit-card-video, ' +
    '.product-gallery__media[data-media-type="video"] video-media';

  const seen = new WeakSet();

  function play(video, shell) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;

    shell?.setAttribute('data-allisit-playing', '');

    video.play().catch(() => {
      shell?.removeAttribute('data-allisit-playing');
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, intersectionRatio }) => {
      const shell = target.matches('video-media') ? target : null;
      const video = shell ? shell.querySelector('video') : target;
      if (!video) return;

      if (intersectionRatio >= 0.45) {
        play(video, shell);
      } else {
        video.pause();
        shell?.removeAttribute('data-allisit-playing');
      }
    });
  }, { threshold: [0, 0.45] });

  function scan() {
    document.querySelectorAll(selector).forEach((target) => {
      if (seen.has(target)) return;

      const shell = target.matches('video-media') ? target : null;
      const video = shell ? shell.querySelector('video') : target;
      if (!video) return;

      seen.add(target);

      if (shell) {
        video.addEventListener('pause', () => {
          shell.removeAttribute('data-allisit-playing');
        });

        shell.addEventListener('click', () => {
          if (video.paused) play(video, shell);
        });
      }

      observer.observe(target);
    });
  }

  function showFirstVideoOnMobile() {
    if (!matchMedia('(max-width: 999px)').matches) return;

    document.querySelectorAll('.product-gallery__media-list')
      .forEach((gallery) => {
        if (gallery.firstElementChild?.dataset.mediaType === 'video') {
          gallery.scrollTo({ left: 0, behavior: 'auto' });
        }
      });
  }

  function init() {
    scan();
    requestAnimationFrame(showFirstVideoOnMobile);
    window.addEventListener('load', showFirstVideoOnMobile, { once: true });

    document.addEventListener('shopify:section:load', () => {
      scan();
      showFirstVideoOnMobile();
    });

    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();